import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ProjectProvider } from "@/context/ProjectContext";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/Guards";
import AppLayout from "@/components/AppLayout";
import LibraryPage from "@/pages/LibraryPage";
import ReaderPage from "@/pages/ReaderPage";
import ComparePage from "@/pages/ComparePage";
import QAPage from "@/pages/QAPage";
import ValidatePage from "@/pages/ValidatePage";
import BuilderPage from "@/pages/BuilderPage";
import MapPage from "@/pages/MapPage";
import ProfilePage from "@/pages/ProfilePage";
import SurfacesPage from "@/pages/SurfacesPage";
import ProjectsPage from "@/pages/ProjectsPage";
import HistoryPage from "@/pages/HistoryPage";
import SettingsPage from "@/pages/SettingsPage";
import HelpPage from "@/pages/HelpPage";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import PricingPage from "@/pages/PricingPage";
import BillingPage from "@/pages/BillingPage";
import LegalPage from "@/pages/LegalPage";
import AdminUsersPage from "@/pages/AdminUsersPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ProjectProvider>
            <Routes>
              <Route path="/login" element={<AuthPage />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/billing" element={<BillingPage />} />
              <Route path="/privacy" element={<LegalPage />} />
              <Route path="/terms" element={<LegalPage />} />
              <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
                <Route path="/" element={<LibraryPage />} />
                <Route path="/reader" element={<ReaderPage />} />
                <Route path="/reader/:id" element={<ReaderPage />} />
                <Route path="/validate" element={<ValidatePage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/help" element={<HelpPage />} />
                <Route path="/history" element={<HistoryPage />} />
                <Route path="/compare" element={<ComparePage />} />
                <Route path="/qa" element={<QAPage />} />
                <Route path="/builder" element={<BuilderPage />} />
                <Route path="/map" element={<MapPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/surfaces" element={<SurfacesPage />} />
                <Route path="/projects" element={<ProjectsPage />} />
                <Route path="/admin/users" element={<AdminUsersPage />} />
              </Route>
            </Routes>
          </ProjectProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#121212",
            border: "1px solid #2A2A2A",
            color: "#FAFAFA",
            borderRadius: "4px",
            fontFamily: "JetBrains Mono, monospace",
            fontSize: "12px",
          },
        }}
      />
    </div>
  );
}

export default App;
